export interface TenantBranding {
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
  headingText: string;
  subheadingText: string;
  landingDescription: string;
  logoUrl?: string;
  faviconUrl?: string;
  footerText?: string;
}

export interface TenantConfig {
  projectName: string;
  domain: string;
  branding: TenantBranding;
  terriaConfigPath: string;
  terriaCatalogPath: string;
}

export const AVAILABLE_TENANTS = [
  'citysense_combined',
  'citysense_building_energy',
  'citysense_urban_mobility',
  'dip_combined',
  'blanchardstown_dip',
  'docklands_dip',
  'climate_plus',
  'climateplus_combined',
  'maris_combined'
] as const;

export type TenantName = typeof AVAILABLE_TENANTS[number];


export interface DashboardOption {
  id: string;
  title: string;
  description: string;
  icon: string;
  catalogFile?: string; 
  targetProject: TenantName;
  targetUrl: string;
  componentType?: string; // Optional property to indicate if it's a custom component
  route?: string; // Optional property for custom component route
}

export interface DashboardConfig {
  projectType: 'combined' | 'single';
  displayName: string;
  description: string;
  options?: DashboardOption[];
}

export const COMBINED_PROJECTS: TenantName[] = [
  'citysense_combined',
  'dip_combined',
  'climateplus_combined',
  'maris_combined'
];

export function isCombinedProject(project: TenantName): boolean {
  return COMBINED_PROJECTS.includes(project);
}